import React from 'react';
import raw from 'raw.macro';
import { ShaderSource } from './Editor';
import './styles/App.scss';
import MainMenu from './MainMenu';

const sources: ShaderSource[] = [
  {
    src: raw("../shaders/base.glsl"),
    filename: "base.glsl",
  },
  {
    src: raw("../shaders/camera_2d.glsl"),
    filename: "camera_2d.glsl",
  },
  {
    src: raw("../shaders/escape_time_2d.glsl"),
    filename: "escape_time_2d.glsl",
  },
  {
    src: raw("../shaders/de_2d.glsl"),
    filename: "de_2d.glsl"
  },
  {
    src: raw("../shaders/mandelbrot.glsl"),
    filename: "mandelbrot.glsl",
  },
  {
    src: raw("../shaders/power_tower.glsl"),
    filename: "power_tower.glsl",
  },
  {
    src: raw("../shaders/burning_ship.glsl"),
    filename: "burning_ship.glsl",
  },
  {
    src: raw("../shaders/escape_time_coloring.glsl"),
    filename: "escape_time_coloring.glsl"
  },
  {
    src: raw("../shaders/rainbow_gradient.glsl"),
    filename: "rainbow_gradient.glsl"
  },
  {
    src: raw("../shaders/custom_gradient.glsl"),
    filename: "custom_gradient.glsl"
  },
  {
    src: raw("../shaders/thorn.glsl"),
    filename: "thorn.glsl"
  },
  {
    src: raw("../shaders/mean_z_coloring.glsl"),
    filename: "mean_z_coloring.glsl"
  },
  {
    src: raw("../shaders/ducks.glsl"),
    filename: "ducks.glsl"
  },
  {
    src: raw("../shaders/orbit_trap_coloring.glsl"),
    filename: "orbit_trap_coloring.glsl"
  },
  {
    src: raw("../shaders/orbit_trap_2d_point.glsl"),
    filename: "orbit_trap_2d_point.glsl"
  },
  {
    src: raw("../shaders/orbit_trap_2d_cross.glsl"),
    filename: "orbit_trap_2d_cross.glsl"
  },
  {
    src: raw("../shaders/orbit_trap_2d_hoop.glsl"),
    filename: "orbit_trap_2d_hoop.glsl"
  },
  {
    src: raw("../shaders/orbit_trap_bitmap_coloring.glsl"),
    filename: "orbit_trap_bitmap_coloring.glsl"
  },
  {
    src: raw("../shaders/multibrot.glsl"),
    filename: "multibrot.glsl"
  },
  {
    src: raw("../shaders/sphere.glsl"),
    filename: "sphere.glsl"
  },
  {
    src: raw("../shaders/camera_3d.glsl"),
    filename: "camera_3d.glsl"
  },
  {
    src: raw("../shaders/camera_3d_spherical.glsl"),
    filename: "camera_3d_spherical.glsl"
  },
  {
    src: raw("../shaders/raymarcher.glsl"),
    filename: "raymarcher.glsl"
  },
  {
    src: raw("../shaders/ray_trace_3d.glsl"),
    filename: "ray_trace_3d.glsl"
  },
  {
    src: raw("../shaders/path_trace_3d.glsl"),
    filename: "path_trace_3d.glsl"
  },
  {
    src: raw("../shaders/mandelbulb.glsl"),
    filename: "mandelbulb.glsl"
  },
  {
    src: raw("../shaders/mandelbox.glsl"),
    filename: "mandelbox.glsl"
  },
  {
    src: raw("../shaders/sierpinski_pyramid.glsl"),
    filename: "sierpinski_pyramid.glsl"
  },
  {
    src: raw("../shaders/menger.glsl"),
    filename: "menger.glsl"
  },
  {
    src: raw("../shaders/mandelbrot_de_2d.glsl"),
    filename: "mandelbrot_de_2d.glsl"
  },
  {
    src: raw("../shaders/sierpinski_de_2d.glsl"),
    filename: "sierpinski_de_2d.glsl"
  },
  {
    src: raw("../shaders/dragon_curve_2d_de.glsl"),
    filename: "dragon_curve_2d_de.glsl"
  },
  {
    src: raw("../shaders/background_gradient.glsl"),
    filename: "background_gradient.glsl"
  },
  {
    src: raw("../shaders/image_background.glsl"),
    filename: "image_background.glsl"
  },
  {
    src: raw("../shaders/fixed_light.glsl"),
    filename: "fixed_light.glsl"
  },
  {
    src: raw("../shaders/camera_relative_light.glsl"),
    filename: "camera_relative_light.glsl"
  },
  {
    src: raw("../shaders/quaternion_julia.glsl"),
    filename: "quaternion_julia.glsl"
  },
  {
    src: raw("../shaders/3d_color_constant.glsl"),
    filename: "3d_color_constant.glsl"
  },
  {
    src: raw("../shaders/3d_orbit_trap_coloring.glsl"),
    filename: "3d_orbit_trap_coloring.glsl"
  },
  {
    src: raw("../shaders/orbit_trap_3d_point.glsl"),
    filename: "orbit_trap_3d_point.glsl"
  },
  {
    src: raw("../shaders/orbit_trap_3d_cross.glsl"),
    filename: "orbit_trap_3d_cross.glsl"
  },
];

export default function App() {
  return (
    <MainMenu sources={sources}></MainMenu>
  );
}
